export default function (state = {}, action) {
   switch (action.type) {

      case 'GET_ASSETS':
         {
            return {
               ...state,
               assetsPayload: action.payload
            };
         }
      case 'GET_ASSET_LIST':
         {
            return {
               ...state,
               assetListPayload: action.payload
            };
         }
      default:
         return state;
   }
}
